import React from 'react';
import { Accordion, Image } from 'shared/lib/SureDesignSystem';
import faqPattern from './assets/pattern.svg';
import styles from './FAQSection.module.css';
import LazyLoad from 'react-lazyload';

export default function FAQSection() {
  return (
    <div className={styles.faqSection}>
      <div className={styles.faqSection_container}>
        <LazyLoad height={522} width={223} once>
          <Image src={faqPattern} className={styles.faqSection_pattern} />
        </LazyLoad>
        <div className={styles.faqSection_content}>
          <h2 className={styles.faqSection_title}>People Often Ask...</h2>
          <Accordion
            itemClassName={styles.faqSection_item}
            items={[
              {
                id: 1,
                title: 'How do I get SURE?',
                description:
                  'Simply search for the SURE app in the Apple App Store or Google Play, it’s free to download. Once you register you can use SURE to make Smart Life Decisions™.',
              },
              {
                id: 2,
                title: 'Where can SURE be used?',
                description:
                  'You can use Sure from your smartphone or on the web.',
              },
              {
                id: 3,
                title: 'How do I know what my policy covers?',
                description:
                  'A summary of your coverage and a sample policy is available to you when you sign up, and before you pay. You can edit your coverage, policy settings, such as the deductible, start dates, and more. After payment, we will instantly issue your final policy and send it to you by email.',
              },
              {
                id: 4,
                title: 'How do I file a claim?',
                description:
                  'Go to the Claims page on our website and click the “Submit a Claim” button. From there you will be guided through a short process.',
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}
